import type { Dispatch } from "@reduxjs/toolkit";

// @ts-expect-error - authuser.js は JS で型定義なし
import { userApi } from "../accounts/authuser";
import { transactionsApi } from "./transactions";

/**
 * オファースレッドの状態 / 金額が変わったときに、アカウントポップオーバーの
 * 残高（`CurrentUser`）と進行中一覧（`Transactions`）を再取得させるための
 * キャッシュ無効化。
 *
 * 操作者本人（`updateDmThread` の onQueryStarted）と相手側（WS 受信フック
 * `useOfferAccountSync`）の双方から呼ばれるため、無効化対象タグをここに集約する。
 */
export const invalidateOfferAccountCaches = (dispatch: Dispatch): void => {
  dispatch(userApi.util.invalidateTags(["CurrentUser"]));
  dispatch(transactionsApi.util.invalidateTags(["Transactions"]));
};
